import ContentOverlay from "../components/content_overlay";

function ExpertsPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Experts</h2>}
      text_content={
        <ol>
          <li style={{ fontSize: "1.2em" }}>
            Dr. Ramachandra T.V
            <p style={{ fontSize: "0.8em" }}>
              Co-ordinator, EWRG, CES, Indian Institute of Science, Bangalore
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialization: Water Quality, Ecology, Ecosystems,
              Sustainability, Environment, Biodiversity, Wetlands, Pattern
              Recognition, Biodiversity &amp; Conservation, Land Use Change,
              Urbanism, Land Use, Aquatic Ecosystems
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail Id: <a href="mailto:tvr@iisc.ac.in">tvr@iisc.ac.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Contact No: 91-080-22933099(D)/22933503 (extn 107)
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. M D Subash Chandran
            <p style={{ fontSize: "0.8em" }}>
              Consultant, Energy and Wetlands Research Groups, Centre for
              Ecological Sciences (CES) Field Station,&nbsp;Indian Institute of
              Sciences,&nbsp;Kumta &ndash; 581 343. Uttara Kannada, Karnataka
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialization: Biodiversity, Endangered species, Ecology,
              Forest management, Hydrology, Coastal ecology, Botany,
              Sustainability
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Email id:{" "}
              <a href="mailto:subashc@iisc.ac.in">subashc@iisc.ac.in</a> ;{" "}
              <a href="mailto:mdschandra@yahoo.com">mdschandra@yahoo.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. Bharath Setturu
            <p style={{ fontSize: "0.8em" }}>
              School of Mathematics &amp; Social Sciences, Chanakya University
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialization: Spatial Informatics, Image Processing,
              Landscape Modeling, Spatial Decision Support System (SDSS)
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail Id:{" "}
              <a href="mailto:bharath.settur@gmail.com">
                bharath.settur@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. Bharath H Aithal
            <p style={{ fontSize: "0.8em" }}>
              Ranbir and Chitra Gupta School of Infrastructure Design and
              Management (RCG SIDM)
            </p>
            <p style={{ fontSize: "0.8em" }}>
              3rd floor, IIT Kharagpur, West Bengal, Pin:&nbsp; 721302, Below
              Coral.
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialization: Spatial analysis, Geoinformation, Urban
              Analysis, climate change, Urban sprawl, land use modelling,
              Machine learning and Deep learning in Geoinformatics
            </p>
            <p style={{ fontSize: "0.8em" }}>Phone: +91 03222304944</p>
            <p style={{ fontSize: "0.8em" }}>
              Email id:{" "}
              <a href="mailto:bharath@infra.iitkgp.ac.in">
                bharath@infra.iitkgp.ac.in
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. Vinay S
            <p style={{ fontSize: "0.8em" }}>
              Energy and Wetlands Research Groups, Centre for Ecological
              Sciences (CES) Field Station, Indian Institute of Sciences, Kumta
              &ndash; 581 343. Uttara Kannada, Karnataka.
            </p>
            <p style={{ fontSize: "0.8em" }}>Telephone: 9916488990</p>
            <p style={{ fontSize: "0.8em" }}>
              Email id: <a href="mailto:vinays@iisc.ac.in">vinays@iisc.ac.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. R Raghavendra Rao
            <p style={{ fontSize: "0.8em" }}>
              Specialization: Plant Taxonomy, Ethnobotany, Phytogeography and
              Biodiversity &amp; Conservation.
            </p>
            <p style={{ fontSize: "0.8em" }}>
              No. 328, B-4, Kendriya Vihar, Yelahanka
            </p>
            <p style={{ fontSize: "0.8em" }}>Bengaluru 560 064, Karnataka</p>
            <p style={{ fontSize: "0.8em" }}>
              Email ID:{" "}
              <a href="mailto:raocimap@gmail.com">raocimap@gmail.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. Madhav Gadgil
            <p style={{ fontSize: "0.8em" }}>
              Member of the National Tiger Conservation Authority
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialization: Ecology, Ecological History, Environmental
              Management and Traditional Knowledge Systems
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Email:{" "}
              <a href="mailto:madhav.gadgil@gmail.com">
                madhav.gadgil@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. M Sanjappa
            <p style={{ fontSize: "0.8em" }}>
              INSA Senior Scientist, Botanical Garden, University of
              Agricultural Sciences, GKVK, Bengaluru 560064
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Specialization: Taxonomy of Plants, Conservation
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Email ID:{" "}
              <a href="mailto:sanjappam@gmail.com">sanjappam@gmail.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. G R Rao
            <p style={{ fontSize: "0.8em" }}>
              Associate Professor, Centre for Urban ecology, Biodiversity,
              Evolution &amp; Climate change (CUBEC), JAIN
              (Deemed-to-be-University), Bengaluru, Karnataka, India
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Email ID: <a href="mailto:grrao1@gmail.com">grrao1@gmail.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Dr. R. Gadagkar
            <p style={{ fontSize: "0.8em" }}>
              Centre for Ecological Sciences, IISc, Bangalore
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Specialization: Evolution of Social Life in Insects, Insect
              Ecology, Biogeography and Biodiversity, Social Organisation and
              Division of Labour in Insect Societies
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Email ID: <a href="mailto:ragh@iisc.ac.in">ragh@iisc.ac.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            N. S. Pradeep
            <p style={{ fontSize: "0.8em" }}>
              Scientist-in-Charge, KSCSTE &ndash; Malabar Botanical Garden &amp;
              Institute for Plant Sciences
            </p>
            <p style={{ fontSize: "0.8em" }}>Telephone: 9496669365</p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail:{" "}
              <a href="mailto:directormbgips@gmail.com">
                directormbgips@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            P.S. Easa
            <p style={{ fontSize: "0.8em" }}>Former Director, KFRI</p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Wild Life Biology
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Mathew Dan
            <p style={{ fontSize: "0.8em" }}>
              Former Principal Scientist, JNTBGRI
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Taxonomy, Ethno-botany and Botany
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Sam. P. Mathew
            <p style={{ fontSize: "0.8em" }}>
              Former Principal Scientist, JNTBGRI, Palode
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Plant Taxonomy &amp; PGR Conservation
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            A Rasiya Beegam
            <p style={{ fontSize: "0.8em" }}>
              Senior Scientist, JNTBGRI, Palode
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Taxonomy and Conservation Biology
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            P. G. Latha
            <p style={{ fontSize: "0.8em" }}>Former Director JNTBGRI</p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Plant Tissue Culture, Plant Cytogenetics,
              Ethnomedicine, Ethnopharmacology of Medicinal Plants
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Satheesh George
            <p style={{ fontSize: "0.8em" }}>
              Assistant Professor, Dept. Of Botany, St. Josephs College,
              Devagiri Kozhikode, Kerala, India - 673008
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Phyto chemistry, Biotechnology, Plant
              Taxonomy
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            K. Radhakrishnan
            <p style={{ fontSize: "0.8em" }}>
              Former Principal Scientist,&nbsp;JNTBGRI, Palode
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Ethnobotany, Plant Taxonomy, Biodiversity
              related to Traditional Knowledge and Eco-education
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Gangaprasad A
            <p style={{ fontSize: "0.8em" }}>
              Former Professor, Department of Botany, University of Kerala,
              Karyavattom, Thiruvananthapuram, Kerala
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Plant Biotechnology (Tissue Culture,
              Molecular Biology) Bio production, Conservation Biotechnology,
              Biosystematics, Medicinal Plant Taxonomy, Ethnopharmacology
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            T.K Hrideek
            <p style={{ fontSize: "0.8em" }}>
              Senior Scientist (on Deputation to SMPB, Kerala), Department of
              Forest Genetics and Tree Breeding Forest Genetics and
              Biotechnology Division KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Genetics and tree Breeding programmes,
              Medicinal Plants, Invasion biology
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail:{" "}
              <a href="mailto:hrideek@kfri.res.in">hrideek@kfri.res.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Manju C Nair
            <p style={{ fontSize: "0.8em" }}>
              Associate Professor, Dept. of Botany, University of Calicut,
              Calicut University P.O, Kerala 673635
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Bryophyte, Taxonomy, Ecology, Molecular
              Biology
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Thomas Mathew P
            <p style={{ fontSize: "0.8em" }}>
              Former Associate Professor, Dept. of Botany, Union Christian
              College, Aluva, Kerala
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Angiosperm Taxonomy, Conservation
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            M. Sabu
            <p style={{ fontSize: "0.8em" }}>Emiritus Scientist, MBGIPS</p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Musaceae, Marantaceae and Zingiberaceae
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail: <a href="mailto:msabu9@gmail.com">msabu9@gmail.com</a>
              &nbsp;
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            N. Sasidharan
            <p style={{ fontSize: "0.8em" }}>
              Former Scientist, Kerala Forest Research Institute, Peechi,
              Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Forest Flora of Kerala; Tree Systematics;
              Non-wood forest produces; Medicinal plants; Biodiversity
              Conservation
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail: <a href="mailto:sasi@kfri.org">sasi@kfri.org</a>,{" "}
              <a href="mailto:sasimedinilla@gmail.com">
                sasimedinilla@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            P A Jose
            <p style={{ fontSize: "0.8em" }}>
              Former Principal Scientist, Department of Tree Physiology Forest
              Ecology &amp; Biodiversity Conservation Division, KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Forest trees/ecosystems and Climate
              change. Development of propagation protocols for forestry and
              medicinal plants. Restoration of threatened Species/ Ecosystems.
              Eco physiology and plant adaptation studies. Seed physiology of
              recalcitrant species
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail: <a href="mailto:pajose@kfri.res.in">pajose@kfri.res.in</a>
              , <a href="mailto:pajosekfri@gmail.com">pajosekfri@gmail.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            T.V Sajeev
            <p style={{ fontSize: "0.8em" }}>
              Chief Scientist, Department of Forest Entomology Forest Health
              Division, KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Landscape fragmentation, Population
              Dynamics of insects, Political Ecology, Biological control &amp;
              Management of Invasive Alien Species
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail: <a href="mailto:sajeev@kfri.res.in">sajeev@kfri.res.in</a>
              ,&nbsp; <a href="mailto:tvsajeev@gmail.com">tvsajeev@gmail.com</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            Adarsh C.K.
            <p style={{ fontSize: "0.8em" }}>
              Junior Scientist/Scientist B, Department of Silviculture
              Sustainable Forest Management Division KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Forest ecology, biodiversity, conservation
              biology, forest mensuration, dendrochronology, forest health
              assessment, carbon sequestration in tropical ecosystems, threat to
              forest ecosystems: invasive alien species, eco-restoration,
              climate change mitigation strategies, seed biology and nursery
              techniques.
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail:{" "}
              <a href="mailto:adarshck@kfri.res.in">adarshck@kfri.res.in</a>,{" "}
              <a href="mailto:adarshckcof09@gmail.com">
                adarshckcof09@gmail.com
              </a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            M P Sujatha
            <p style={{ fontSize: "0.8em" }}>
              Former Chief Scientist, Department of Soil Science Sustainable
              Forest Management Division, KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Forest ecosystems, Species soil matching,
              Soil carbon sequestration
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail:{" "}
              <a href="mailto:sujatha@kfri.res.in">sujatha@kfri.res.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            V.B Sreekumar
            <p style={{ fontSize: "0.8em" }}>
              Principal Scientist, Department of Forest Botany Forest Ecology
              &amp; Biodiversity Conservation Division, KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: General floristics, Plant systematics and
              phyloclimatic studies, Phenology &amp; Seed Dispersal
            </p>
            <p style={{ fontSize: "0.8em" }}>
              E-mail:{" "}
              <a href="mailto:sreekumar@kfri.res.in">sreekumar@kfri.res.in</a>
            </p>
            <p style={{ fontSize: "0.8em" }}>&nbsp;</p>
          </li>
          <li style={{ fontSize: "1.2em" }}>
            K.A Sreejith
            <p style={{ fontSize: "0.8em" }}>
              Principal Scientist, Department of Forest Ecology Forest Ecology
              &amp; Biodiversity Conservation Division KFRI, Thrissur
            </p>
            <p style={{ fontSize: "0.8em" }}>
              Area of Specialisation: Forest ecosystems, plant ecophysiology,
              Plant functional traits
            </p>
          </li>{" "}
        </ol>
      }
    />
  );
}

export default ExpertsPage;
